import React from "react";
import { useTheme } from "../../../hooks";
import { GenericModalDiv } from "./GenericModalStyles";
import ModalBody from "./body/ModalBody";
import ModalFooter from "./footer/ModalFooter";
import ModalHeader from "./header/ModalHeader";
const GenericModal = ({ children, styles }) => {
    const { Theme } = useTheme();
    const StylesOverride = { ...Theme.modal, ...styles };
    return (React.createElement(GenericModalDiv, { styles: StylesOverride }, React.Children.map(children, (child) => {
        if (!child || !child.type || !React.isValidElement(child)) {
            return null;
        }
        else if (child.type === ModalHeader || child.type === ModalBody || child.type === ModalFooter) {
            return child;
        }
        else if (
        //@ts-ignore
        child.type?.displayName === ModalHeader.displayName ||
            //@ts-ignore
            child.type?.displayName === ModalBody.displayName ||
            //@ts-ignore
            child.type?.displayName === ModalFooter.displayName) {
            return child;
        }
        else {
            return null;
        }
    })));
};
GenericModal.Header = ModalHeader;
GenericModal.Body = ModalBody;
GenericModal.Footer = ModalFooter;
export default GenericModal;
//# sourceMappingURL=GenericModal.js.map